import css from 'src/utils/css';

export default function ReactQuillValueRender({ value }) {
  const baseClasses = css`
    .textQuill {
      max-width: 100%;
      overflow: hidden;
      img {
        max-width: 100%;
      }
    }
  `;

  return (
    <div
      className={baseClasses.textQuill}
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
}
